var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),(_vm.showSpinner)?_c('half-circle-spinner',{staticClass:"auth-ui-main-spinner",attrs:{"animation-duration":1000,"size":30}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }